import { Disabled } from './disabled-fallback';

interface ComponentGuardProps {
	allowed: boolean | (() => boolean);
	children: any;
	fallback?: React.ComponentType<any>;
	notAllowedTooltip?: string;
}

export const ComponentGuard: React.FC<ComponentGuardProps> = ({
	allowed,
	children,
	fallback: Fallback = null,
	notAllowedTooltip = 'Not Allowed'
}) => {
	return allowed ? children : Fallback ? <Fallback tooltipTitle={notAllowedTooltip}>{children}</Fallback> : null;
};
